import {Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import {AuthenticationService} from '../../../services/authentication.service';
import {ToastrService} from 'ngx-toastr';
import {timer} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {UserService} from "../../../services/user.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class NewLoginComponent implements OnInit {

  verification_id: string;
  user_id: string;
  pin: string;
  first_name: string;
  last_name: string;
  phone_number: any;
  password1: string;
  password2: string;
  gender: string;
  stage = 0;

  userExists = false;
  password: any;
  loading = false;

  countDown;
  counter = 60;
  tick = 1000;

  constructor(private authentication: AuthenticationService, private toastr: ToastrService,
              private http: HttpClient, private router: Router,
              private userService: UserService) {
  }

  ngOnInit(): void {
  }


  check_phone_number(): void {
    this.loading = true;
    this.authentication.isPhoneNumberExist(this.phone_number).then(res => {
      // console.log(res);
      this.userExists = res.exists;
      this.stage = 1;
      if (!this.userExists) {
        this.countDown = timer(0, this.tick).pipe(map(() => --this.counter), take(this.counter));
        this.verification_id = res.verification_id;
      }
      this.loading = false;
    }).catch(err => {
      this.loading = false;
    });
  }

  check_pin(): void {
    this.loading = true;
    const data = {verification_id: this.verification_id, pin: parseInt(this.pin, 10)};
    this.http.post('api/user/verify_pin', data)
      .subscribe((res: any) => {
        if (res.result) {
          this.user_id = res.user_id;
          this.stage = 2;
        }
        this.loading = false;
      }, error => {
        this.loading = false;
      });
  }

  login(): void {
    this.loading = true;
    this.authentication.login(this.phone_number, this.password).then(res => {

      this.loading = false;
      this.router.navigate(['/' + this.userService.getRole() + '/dashboard']);
    }).catch((err: any) => {
      this.loading = false;
    });
  }

  resendCode(): void {
    this.countDown = timer(0, this.tick).pipe(map(() => --this.counter), take(this.counter));

  }

  complete_signup(): void {
    this.loading = true;
    const data = {
      verification_id: this.verification_id,
      user_id: this.user_id,
      first_name: this.first_name,
      last_name: this.last_name,
      password: this.password1
    };
    this.http.post('api/user/complete_sign_up', data)
      .subscribe((res: any) => {
        this.router.navigate(['/']);
        this.loading = false;
      }, error => {
        this.loading = false;
      });
  }
}
